export const TIERED_BAR_CONFIG: Highcharts.Options = {
  chart: { type: "bar" },
  title: { text: "", align: "left" },
  legend: {
    enabled: true,
    align: "left",
    verticalAlign: "top",
    layout: "horizontal",
    itemStyle: { fontSize: "12px", fontWeight: "normal", color: "#333" },
  },
  credits: { enabled: false },
  accessibility: { enabled: false },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
};
